import { DickTokComponent } from "./Component.js";
import { defineElement } from "./registry.js";

export class DickTokAd extends DickTokComponent {}

defineElement("dicktok-ad", DickTokAd);
